import { render, staticRenderFns } from "./precreateIndex.vue?vue&type=template&id=065ba930&scoped=true&"
import script from "./precreateIndex.vue?vue&type=script&lang=js&"
export * from "./precreateIndex.vue?vue&type=script&lang=js&"
import style0 from "./precreateIndex.vue?vue&type=style&index=0&id=065ba930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ba930",
  null
  
)

export default component.exports